module.exports = __webpack_public_path__ + "static/media/SuisseIntl-Regular-WebS.fa827265.svg";